import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import UsernamePasswordPage from './UsernamePasswordPage';
import {
  dataCaptureSelectors,
  saveUsernamePasswordForm,
  getExistingUser,
  redirectToPersonalDetails
} from '../../store/dataCapture';
import { USERNAME_PASSWORD, CASE_ID, CREATE_CASE_ERROR } from '../../utils/constants';
import { getQueryStringValueByName } from '../../utils';

const PASSWORD_MAXLENGTH = 16;
class UsernamePasswordSection extends Component {
  constructor(props) {
    super(props);
    this.onPasswordValueChange = this.onPasswordValueChange.bind(this);
    this.state = {
      isPristine: false,
      passwordValue: ''
    };
  }

  componentDidMount() {
    if (this.props.isExisting && !getQueryStringValueByName(CASE_ID)) {
      this.props.getExistingUser();
    }
  }

  onPasswordValueChange(value) {
    if (value === '' || (value && value.length <= PASSWORD_MAXLENGTH)) {
      this.setState({ passwordValue: value });
    }
  }

  render() {
    const {
      bankId,
      brandId,
      saveUsernamePasswordForm,
      getBusinessData,
      isExisting,
      createCaseErrorMessage
    } = this.props;

    return (
      <UsernamePasswordPage
        brandId={brandId}
        bankId={bankId}
        saveUsernamePasswordForm={values => {
          this.setState({ isPristine: true });
          saveUsernamePasswordForm(values);
        }}
        onPasswordValueChange={this.onPasswordValueChange}
        passwordValue={this.state.passwordValue}
        isExisting={isExisting}
        isPristine={this.state.isPristine}
        createCaseErrorMessage={createCaseErrorMessage}
        getBusinessData={getBusinessData}
      />
    );
  }
}

UsernamePasswordSection.propTypes = {
  brandId: PropTypes.brandId,
  bankId: PropTypes.bankId,
  saveUsernamePasswordForm: PropTypes.func.isRequired
};

const actionCreators = {
  saveUsernamePasswordForm,
  getExistingUser,
  redirectToPersonalDetails
};

const mapStateToProps = state => ({
  brandId: selectors.brandId(state),
  bankId: selectors.bankId(state),
  getBusinessData: dataCaptureSelectors.getBusinessData(state, USERNAME_PASSWORD),
  isExisting: selectors.isExisting(state),
  caseType: selectors.caseType(state),
  createCaseErrorMessage: dataCaptureSelectors.getBusinessData(state, CREATE_CASE_ERROR)
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UsernamePasswordSection);
